import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import { Redirect } from 'react-router-dom';
import * as QueryString from 'query-string';
import { Form, Row, Col, Image } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import Storage from '../../support/Storage';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';
import ReCAPTCHA from 'react-google-recaptcha';

class ReceptoresSignInSso extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({}))
    };

    this.recaptchaRef = createRef();
  }

  async componentDidMount() {
    let isLoggedIn = Auth.isAuthenticated();

    if (!Auth.isAuthenticated() && !!Auth.getUser()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isLoggedIn = true;
      }
    } else {
      await Auth.logout();
    }

    if (isLoggedIn) {
      this.setState({
        isLoggedIn
      });
    } else {
      setTimeout(() => {
        this.setState({
          loaded: true
        });
      });
    }
  }

  getRules(data) {
    if (!!data.username) {
      return {
        username: ['required', 'email']
      }
    }

    if (!!data.username && data.username.indexOf('@') === -1) {
      return {
        username: ['required', 'string', 'numeric', 'regex:/^[0-9]{10}$/']
      }
    }

    return {
      username: ['required', 'email']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true
    });

    try {
      const token = await this.recaptchaRef.current.executeAsync();

      const params = {
        ...this.state.data,
        challenge: token
      }

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }
      const response = await Http.post('/receptores/auth/tokens', params, { headers });

      this.setState({
        result: response,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Solicitud completada"
          result={ result }
          onAction={ () => {} }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      isValid,
      isLoggedIn,
      busy,
      loaded,
      error,
      result
    } = this.state;

    const rules = this.getRules(data);

    // const { onForgotPasswordClick } = this.props;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };

      if (from.pathname === '/ext/receptores/auth/sso') {
        from.pathname = '/ext/receptores/facturas';
      }

      return <Redirect to="/bridge/receptores" state={ from } />;
    }

    if (!loaded) {
      return <Row></Row>
    }

    if (result) {
      return this.renderResult();
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <Row className="auth-logo">
              <Col className="d-flex justify-content-start logo-container">
                  <Image src="/img/logo.png"
                    className="auth-logo-img"
                    fluid={ true }
                  />
                  <span>Facturotöpía</span>
              </Col>
            </Row>
          </div>

          <div className="login-content">
            <div className="pb-3">
              <h6 className="text-muted">
                Inicia sesión para continuar
              </h6>
            </div>

            <div id="output"></div>

            <div className="form-box">
              <FormControl type="username"
                name="username"
                placeholder="tu-email@facturotopia.com"
                help="Ingresa tu correo electrónico"
                autoFocus={ true }
                rules={ rules.username }
                value={ data.username }
                onChange={ this.handleOnChange }
              />

              <ReCAPTCHA
                size="invisible"
                ref={ this.recaptchaRef }
                sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                onChange={ this.onCaptchaChange }
              />

              <Row>
                <Col className="text-right">
                  <LoadingButton type="button"
                    block={ true }
                    loading={ busy }
                    disabled={ !isValid || busy }
                    onClick={ this.handleOnSubmit }
                  >
                    { busy && 'Verificando...'}
                    { !busy && 'Continuar' }
                  </LoadingButton>
                </Col>
              </Row>

              <div className="pt-3">
              { !!error && this.renderError() }
              </div>

            </div>
          </div>

          <Row className="pt-4 pb-3">
            <Col>
              <small className="text-muted">
                Al continuar aceptas nuestros <a href="/">Términos del servicio</a> y nuestro <a href="/">Acuerdo de privacidad</a>
              </small>
            </Col>
          </Row>

        </div>
      </Form>
      )
    }
  }

  export default ReceptoresSignInSso;
